var MinimalTheme = {};

jQuery(window).ready(function(){
  
  
  $('.flexslider').flexslider({
    animation: "slide",
    slideshow: true,
    animationDuration: 700,
    slideshowSpeed: 6000,
    animation: "fade",
    controlsContainer: ".flex-controls",
    controlNav: false,
    keyboardNav: true
  }).hover(function(){ $('.flex-direction-nav').fadeIn();}, function(){$('.flex-direction-nav').fadeOut();});
  
});

jQuery(window).load(function(){  

  $("select.loc_on_change").change(function(){
    if($(this).find(":selected").attr("value") == "#") return false;
    window.location = $(this).find(":selected").attr("value");
  });
   
});

jQuery(document).ready(function($){

 

  setTimeout(function() {
     $('.custompopup-wrap').fadeIn();
  }, 4000);
    
  // force wide nav -->  
  
  // <-- end force wide nav
  
  $(".flyout").hide();

  $("#menu-button").on("click", function() {
    $(".flyout").slideToggle( "fast" );
  });

  $(".sub-menu").hide();
  $(".more, .account-links").on("click", function() {
    $(this).nextAll("ul").slideToggle( "fast" );
    $("i", this).toggleClass("fa-plus fa-minus");
    $(this).next(".more").find("i").toggleClass("fa-user fa-minus");
  });  

  $("nav.mobile select").change(function(){ window.location = jQuery(this).val(); });
     
  $("a.fancy").fancybox({
    padding: 0,
	prevEffect : 'none',
	nextEffect : 'none',
  });
   
  
  
  MinimalTheme.switchImage = function(newSizedImageSrc, newImage, mainImageDomEl) {
    var largestImage = newSizedImageSrc.replace('_1024x1024', '');
    $(mainImageDomEl)
      .attr('src', newSizedImageSrc)
      .parents('a')
      .attr('href', largestImage);
    
  };
  
  $('#product .thumbs a').click(function(e){
    e.preventDefault();
    //var newSizedImageSrc = $(this).attr('href');
    //var mainImageDomEl = $('.image.featured img')[0];
    //MinimalTheme.switchImage(newSizedImageSrc, null, mainImageDomEl);
    $('.image.featured').find('.active').removeClass('active');
    var index = $(this).data('thumbindex');
    $('*[data-index="'+index+'"]').addClass('active');
    
  });
  
  $('input[type="submit"], input.btn, button').click(function(){ // remove ugly outline on input button click
    $(this).blur();
  })
  
  $('li.dropdown').hover(function(){
    $(this).children('.dropdown').show();
    $(this).children('.dropdown').stop();
    $(this).children('.dropdown').animate({
      opacity: 1.0
    }, 200);
  }, function(){
    $(this).children('.dropdown').stop();
    $(this).children('.dropdown').animate({
      opacity: 0.0
    }, 400, function(){
      $(this).hide();
    });
  });
  
  /* mobile - change large image on thumb click */
  $('#product-media-small').find('.thumbs').find('.image').find('a').on('click', function(e) {
    e.preventDefault();
    $('#product-media-small').find('.media-small-image').find('img').attr('src', $(this).attr('href'));
  });
  
  /* Lee addition for rollover for footer */
  $(document).ready(function() {
	$('.whitebar a img, .logo a img').hover(function() {
		$(this).stop().fadeTo("medium", 0.5);
	}, function() {
		$(this).stop().fadeTo("medium", 1);
	});
});
  
});


//Mailchimp popup for mobile
jQuery(document).ready(function($){
      var $close = $('.close');
      var $popup = $('.popup-content');
      var seconds = 5000;

      $close.on('click',function(){
          $popup.removeClass('on');
          setCookie("MCPopupClosed","yes",90);
      });

      //this function loads the box subscription
      var loadSubscription = function(){
        var closeAction = getCookie("MCPopupClosed");
        var subscribedAction = getCookie("MCPopupSubscribed");


        if (closeAction == "" && subscribedAction == "") {
          setTimeout(function(){
            $popup.addClass('on');
          }, seconds);
        }
      }

      //function to close + create cookie
      var closeSubscription = function(){
          setCookie("MCPopupSubscribed","yes",90);
          $( "#subscribe" ).fadeOut(function(){
            $( ".respond" ).fadeIn();
            setTimeout(function(){
              $popup.removeClass('on');
            }, 2000);
          });
      }


      function setCookie(cname, cvalue, exdays) {
          var d = new Date();
          d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
          var expires = "expires="+d.toUTCString();
          document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
      }

      function getCookie(cname) {
          var name = cname + "=";
          var ca = document.cookie.split(';');
          for(var i = 0; i < ca.length; i++) {
              var c = ca[i];
              while (c.charAt(0) == ' ') {
                  c = c.substring(1);
              }
              if (c.indexOf(name) == 0) {
                  return c.substring(name.length, c.length);
              }
          }
          return "";
      }

      //calling functions
      loadSubscription();

       $( "#subscribe" ).submit(function( event ) {

             event.preventDefault();

              $.ajax({

                  type: "GET",
                  url: "https://contemporaryeditions.us15.list-manage.com/subscribe/post-json?u=4dc827830cb59f3acfa7bb22d&id=93dccd11c6",
                  data: $( "#subscribe" ).serialize(),
                  cache: false,
                  dataType: "jsonp",
                  jsonp: "c", // trigger MailChimp to return a JSONP response
                  contentType: "application/json; charset=utf-8",

               }).done(function(data){
                   console.log(data.msg);
                   closeSubscription();

                }).fail(function(err){

                        console.log('error:'+err)
                    
                });
        });

    });